import React from 'react';
import LegalPage from '../components/LegalPage';
import TermsAndConditionsContent from '../components/TermsAndConditionsContent';

const TermsAndConditions: React.FC = () => (
  <LegalPage
    title="Terms and Conditions"
    lastUpdated="October 1st, 2023"
    backHref="/en/"
  >
    <TermsAndConditionsContent />
  </LegalPage>
);

export default TermsAndConditions;
